import { createFileRoute, redirect, useParams } from '@tanstack/react-router'
import { WorkspaceDeletionSettings } from '@/features/workspaces/settings'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/deletion'
)({
  beforeLoad: ({ context, params }) => {
    if (!context.canDeleteWorkspace) {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId/settings/general',
        params,
        replace: true,
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { orgId, workspaceId } = useParams({
    from: '/_authenticated/org/$orgId/workspace/$workspaceId/settings/deletion',
  })

  return <WorkspaceDeletionSettings orgId={orgId} workspaceId={workspaceId} />
}
